import React from "react";
import { Header, Faq, SubFooter } from "Atoms/";

export default function faq() {
  return (
    <>
      <Header
        classType="header-int"
        title1="Diamond Head"
        title2="State Monument"
        url="diamondhead"
      />
      <div className="container">
        <div className="row row-padding">
          <div className="col-xl-12">
            <h2>FAQ about Diamond Head State Monument Reservations</h2>
            <p>
              <hr />
              <h4>What time does the park open? </h4>
              Reservations begin at 6:00 am.{" "}
            </p>
      
            <p>
              <hr />
              <h4>When is the last reservation? </h4>
              The last reservation is at 4:00 pm. You must enter the park no later
              than 4:30 pm.
            </p>
      
            <p>
              <hr />
              <h4>How long is the hike? </h4>
              Typically, the hike takes 60-90 minutes.
            </p>
      
            <p>
              <hr />
              <h4>When do I need to leave the park? </h4>
              If you park in the crater, you must exit promptly by the end time of
              your parking reservation. For walk-ins and drop-off visitors, you
              may leave at your leisure upon completion of your hike and visit. All
              visitors must exit via the the tunnel to the crater exterior by 6:00
              pm. After 6:00 pm the park is secured by the Department of Defense.
              Anyone still in the park will be considered trespassing and may face
              prosecution.
            </p>
      
            <p>
              <hr />
              <h4>
                Do I need a reservation and purchase my parking and/or entry fees
                before I arrive?{" "}
              </h4>
              Yes.
            </p>
      
            <p>
              <hr />
              <h4>I have young children. Do I need to pay for them also? </h4>
              Children three (3) years old or younger do not need to pay.{" "}
            </p>
      
            <p>
              <hr />
              <h4>Do you accept visitors without reservations? </h4>
              No. Anyone without a reservation will be turned away (except local
              residents with valid Hawaiʻi State ID).{" "}
            </p>
      
            <p>
              <hr />
              <h4>Do you offer military discounts? </h4>
              Unfortunately, at this time, we do not.
            </p>
      
            <p>
              <hr />
              <h4>
                When I made my reservation, it was only two of us. Now my three
                kids want to go. What can I do?{" "}
              </h4>
              If it is before your reservation start time, you can return to the
              reservation website and purchase the appropriate number of
              additional entry tickets – if space is available. You will be
              charged at that point for the extra visitors in your party.
            </p>
      
            <p>
              <hr />
              <h4>
                I was going to go hiking at Diamond Head and we have reservations
                and tickets. But due to a scheduling conflict, we can no longer
                make it. What can we do?{" "}
              </h4>
              Please return to the reservation website and see if you can cancel
              or modify your reservations. Partial refunds may be offered but are
              not guaranteed. Modification may be possible. But they are not
              guaranteed, and additional fees may apply.
            </p>
      
            <p>
              <hr />
              <h4>
                I have reservations today, but it is raining. Can I get a refund?{" "}
              </h4>
              No, we do not offer refunds due to the weather or any other
              conditions outside of our control, unless there is an official park
              closure due to hazardous conditions or emergency.
            </p>
      
            <p>
              <hr />
              <h4>
                I am bringing my family to hike, but I am unable to physically do
                the hike. Do I still have to pay an entry fee?{" "}
              </h4>
              Yes. Anyone entering the park needs to purchase an entry ticket.
            </p>
      
            <p>
              <hr />
              <h4>
                Originally, when I made the reservations and purchased my entry
                tickets, it was for myself, my wife and two children. Now my two
                children want to go to the beach instead. Can I bring two of my
                relatives in their place?{" "}
              </h4>
              Yes, as long as you do not exceed the number of entries on the
              ticket.
            </p>
      
            <p>
              <hr />
              <h4>
                I am a kamaʻāina, do I need a reservation, and must I purchase
                parking and entry fees?{" "}
              </h4>
              Reservations are not required for all kamaʻāina with valid
              identification issued by the State of Hawaiʻi. Proceed to the entry
              point and show your Hawaiʻi Drivers License or ID.
            </p>
      
            <p>
              <hr />
              <h4>
                I am a kamaʻāina and I have out of state guests with me. Do they
                need a reservation?{" "}
              </h4>
              Yes, your guests require reservations and must purchase parking
              and/or entry tickets. Please do not bring them to the park without
              confirmed reservations, as they will be denied entry.
            </p>
      
            <p>
              <hr />
              <h4>
                I live in the state now, but I do not yet have a Hawaiʻi issued ID.
                Do I need to make a reservation and purchase entry tickets?
              </h4>
              Yes. Once you receive your official Hawaiʻi ID, you will no longer
              need a reservation or pay.
            </p>
      
            <p>
              <hr />
              <h4>
                I am a kamaʻāina and I have a Hawaiʻi issued ID, does this
                guarantee me a parking spot?{" "}
              </h4>
              No. We reserve a portion of our parking lot for kamaʻāina. But we
              cannot guarantee a spot. We will do our best to accommodate you. But
              you may be turned away, if no parking is available. Residents who
              walk in will always be accommodated.
            </p>
          </div>
        </div>
      </div>
      <SubFooter name="Diamond Head State Monument" url="diamondhead" />
    </>
  );
}
